import Dialog from "@components/dialog/Dialog";
import Field from "@components/inputs/field";
import { ISelectionChangeArgs } from "@components/inputs/select/Select.types";
import UserIconSelect from "@components/inputs/select/UserIconSelect";
import i18next from "i18next";
import React from 'react';

import { BasicInputSizes, Status } from "../../enums";
import ConfirmationButtons from "../../views/table/ConfirmationButtons";
import { WithAlert, withAlert } from "@components/alert/withAlert";
import { handover } from "@pages/chats/Chats.utils";

interface IProps extends WithAlert {
    onClose: (reload?: boolean) => void;
    chatIds: string[];
    skippedUserId?: string;
}

interface IState {
    selectedUserId?: string;
}

class HandoverDialog extends React.Component<IProps, IState> {

    state: IState = {
        selectedUserId: null
    };

    handleConfirm = async () => {
        const error = await handover(this.props.chatIds, this.state.selectedUserId);
        if (error) {
            this.props.setAlert(error);
        } else {
            this.props.onClose?.(true);
        }
    }

    handleCancel = () => {
        this.props.onClose?.(false);
    }

    handleChange = (args: ISelectionChangeArgs) => {
        this.setState({
            selectedUserId: args.value as string
        });
    }

    render() {
        return (
            <Dialog
                width="280px"
                title={i18next.t("Chat:Handover")}
                onClose={this.handleCancel}
                aretateHeight={false}
                onConfirm={this.handleConfirm}
                footer={<ConfirmationButtons onCancel={this.handleCancel} onConfirm={this.handleConfirm}
                                             useWrapper={false}/>}>
                {this.props.alert}
                <Field
                    isRequired
                    label={i18next.t("Chat:HandoverToWho")}>
                    <UserIconSelect
                        isCustomer
                        skippedUserId={this.props.skippedUserId}
                        value={this.state.selectedUserId}
                        width={BasicInputSizes.L}
                        onChange={this.handleChange}
                    />
                </Field>
            </Dialog>
        );
    }
}

export default withAlert()(HandoverDialog);